import app from '../app.first';

app.UserDetailListing = class extends app.Component {
    onReady () {
        /**
         * candidates selected
         */
        this.$el.on('change', '.user-detail-select', async e => {
            let $parentRow = $(e.target).parents('tr');
            let userDetailId = $(e.target).val();

            let result = await app.ajax(
                `/admin/user-details/select-user/${userDetailId}.json`,
                { selected: e.target.checked },
                false
            );

            if (result && result.selected) {
                $parentRow.addClass('is-selected');
            } else {
                e.target.checked = false;
                $parentRow.removeClass('is-selected');
            }

            $(document).trigger('Admin.UserDetails.selectedIds.change');
        });
    }
}